import hatsApi from '@/services/hatsApi'

export default {
  attachToService (params) {
    return hatsApi().post('/master-data/service-media', params)
  },
  getMedia (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/service-media?filter=' + JSON.stringify(filter))
  },
  downloadMedia (id) {
    return hatsApi().get('/master-data/service-media/download/' + id, {'responseType': 'blob'})
  },
  deleteServiceMedia (id) {
    return hatsApi().delete('/master-data/service-media/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Media.js